// Small target-species pill row.
import { Fish } from "lucide-react";

const SPECIES = [
  "Blue Marlin",
  "Yellowfin Tuna",
  "Mahi Mahi",
  "Wahoo",
  "Bonito",
];

export default function Species() {
  return (
    <section data-testid="species-section" className="aq-bg-foam-deep" style={{ padding: "40px 0" }}>
      <div className="aq-container flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
        <div className="flex items-center gap-2 shrink-0">
          <Fish size={18} style={{ color: "var(--aq-gold)" }} />
          <span className="aq-overline">Targeting · Deep Sea Trolling 5–8 mi Offshore</span>
        </div>
        <ul className="flex flex-wrap gap-2" data-testid="species-pills">
          {SPECIES.map((s) => (
            <li key={s} data-testid={`species-${s.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-[12px] font-medium uppercase tracking-wider"
                style={{
                  padding: "6px 12px",
                  background: "#fff",
                  border: "1px solid #e7e2d3",
                  borderRadius: 999,
                  color: "var(--aq-navy)",
                }}>
              {s}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
